<template>
    <div id="contenedor-control-proyectos-main" class="bkground">
      <v-container fluid>
        <v-card flat class="rounded-lg pa-4">
          <titulo-tool-bar
            titulo="Proyecto"
            nombreRuta="obra"
            regresar>
          </titulo-tool-bar>
          <div
            v-if="!$apollo.queries.proyecto.loading"
            class="rounded-lg grey lighten-4 pa-4 mb-2">
            <div class="font-weight-bold">
              {{ proyecto.obra.clave }} - {{ proyecto.obra.meta }}
            </div>
            <div>
              {{ proyecto.descripcion }}
            </div>
          </div>
          <v-row
            no-gutters
            align="center">
            <v-col
              cols="12"
              md="auto">
              <OpcionesNavegacion />
            </v-col>
            <v-spacer></v-spacer>
            <v-col
              cols="12"
              md="auto">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    rounded
                    class="mr-1">
                    <v-icon small left>
                      mdi-cog
                    </v-icon>
                    Configuración
                  </v-btn>
                </template>
                <v-list dense nav>
                  <v-list-item
                  @click="mostrarCatalogoTiposDocumentos = !mostrarCatalogoTiposDocumentos">
                  <v-list-item-icon class="mr-2">
                    <v-icon>
                      mdi-file-document-alert-outline
                    </v-icon>
                  </v-list-item-icon>
                    <v-list-item-title>
                      Tipos Documentos
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    color="primary"
                    rounded>
                    Nuevo
                    <v-icon small right>
                      mdi-menu-down
                    </v-icon>
                  </v-btn>
                </template>
                <v-list dense nav>
                  <v-list-item
                    @click="mostrarAgregarDocumento = !mostrarAgregarDocumento">
                    <v-list-item-icon class="mr-1">
                      <v-icon small>
                        mdi-file-document-outline
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                      Documento
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="mostrarAgregarProyectoResponsable = !mostrarAgregarProyectoResponsable">
                    <v-list-item-icon class="mr-1">
                      <v-icon small>
                        mdi-file-check-outline
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                      Responsable
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon class="mr-1">
                      <v-icon small>
                        mdi-format-list-checkbox
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                      Tarea
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <!-- Contenido de las opciones -->
          <div style="min-height: 350px;">
            <router-view></router-view>
          </div>
        </v-card>
      </v-container>
      <!-- Ventana tipos documentos -->
      <v-dialog
      v-model="mostrarCatalogoTiposDocumentos"
      width="900"
      scrollable>
      <catalogo-proyecto-documentos-tipos
      v-on:cerrar="mostrarCatalogoTiposDocumentos = !mostrarCatalogoTiposDocumentos">
      </catalogo-proyecto-documentos-tipos>
      </v-dialog>
      <!-- Ventana Agregar Documentos -->
      <v-dialog
        v-if="mostrarAgregarDocumento"
        v-model="mostrarAgregarDocumento"
        width="800">
        <agregar-proyecto-documento
        :idProyecto="this.idProyecto"
        v-on:cerrar="mostrarAgregarDocumento = !mostrarAgregarDocumento">
        </agregar-proyecto-documento>
      </v-dialog>
      <!-- Ventana Agregar Documentos -->
      <v-dialog
        v-if="mostrarAgregarProyectoResponsable"
        v-model="mostrarAgregarProyectoResponsable"
        width="600">
        <v-card>
          <v-card-title class="secondary--text">
          Agregar Responsable
          <v-spacer></v-spacer>
          <v-btn
          icon
          @click="mostrarAgregarProyectoResponsable = !mostrarAgregarProyectoResponsable">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
          <v-card-text>
            <agregar-proyecto-responsable
            ref="agregarProyectoResponsable"
            :idProyecto="this.idProyecto"
            @formularioValido="setFormularioValido"
            @enviandoFormulario="setEnviandoFormulario"
            v-on:cerrar="cerrarAgregarProyectoResponsable">
            </agregar-proyecto-responsable>
          </v-card-text>
          <v-divider class="bkground" />
          <v-card-actions>
            <v-spacer></v-spacer>
            <custom-button
            @click="$refs.agregarProyectoResponsable.cerrar()"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
            </custom-button>
            <custom-button
              @click="$refs.agregarProyectoResponsable.guardarResponsales()"
              :disabled="!formularioValido || enviandoFormulario"
              :loading="enviandoFormulario"
              tipo="formAceptar"
              label="Guardar">
            </custom-button>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </template>

<script>
import PROYECTO from '@/graphql/querys/administracion/control-proyectos/proyecto.gql';
import CatalogoProyectoDocumentosTipos from '@/components/administracion/control-proyectos/documentos-tipos/listado/Desktop.vue';
import AgregarProyectoDocumento from '@/components/administracion/control-proyectos/documentos/Agregar.vue';
import AgregarProyectoResponsable from '@/components/administracion/control-proyectos/responsables/Agregar.vue';
import TituloToolBar from '@/components/TituloToolBar.vue';
import CustomButton from '@/components/buttons/Button.vue';
import OpcionesNavegacion from './OpcionesNavegacion.vue';

export default {
  name: 'MainControlProyectos',
  props: {
    // idObra: {
    //   type: String,
    //   required: true,
    // },
  },
  components: {
    OpcionesNavegacion,
    CatalogoProyectoDocumentosTipos,
    AgregarProyectoDocumento,
    AgregarProyectoResponsable,
    CustomButton,
    TituloToolBar,
  },
  data() {
    return {
      idProyecto: this.$route.params.idProyecto,
      formularioValido: false,
      enviandoFormulario: false,
      mostrarCatalogoTiposDocumentos: false,
      mostrarAgregarDocumento: false,
      mostrarVentanaProyectoDocumentos: false,
      mostrarVentanaProyectoDocumentosLista: false,
      mostrarAgregarProyectoResponsable: false,
    };
  },
  apollo: {
    proyecto: {
      query: PROYECTO,
      variables() {
        return {
          id: this.$route.params.idProyecto,
        };
      },
    },
  },
  methods: {
    cerrarAgregarProyectoResponsable() {
      this.mostrarAgregarProyectoResponsable = false;
      this.enviandoFormulario = false;
      this.formularioValido = false;
    },
    setFormularioValido(valor) {
      this.formularioValido = valor;
    },
    setEnviandoFormulario(valor) {
      this.enviandoFormulario = valor;
    },
  },
};
</script>

<style lang="scss">
// #contenedor-control-proyectos-main {
//   min-height: calc(100svh - 120px);
//   height: calc(100svh - 120px);
// }
</style>
